import Hero from '../../components/newNewProductPage/Hero/Hero';
import Languages from '../../components/newNewProductPage/Languages/Languages';
import Learning from '../../components/newNewProductPage/Learning/Learning';
import CourseValue from '../../components/newNewProductPage/courseValue/CourseValue';
import ExpertSection from '../../components/newNewProductPage/expert/ExpertSection';
import Faq from '../../components/newNewProductPage/faq/Faq';

const NewNewProductPage = ({ data = {} }) => {
  return (
    <div>
      <Hero data={data.hero} />
      <Learning data={data.learning} />
      <Languages data={data.languages} />
      <ExpertSection data={data.expertSection} />
      <CourseValue data={data.courseValue} />
      <Faq data={data.faq} />
    </div>
  );
};

export default NewNewProductPage;
